<template lang="html">

  <section class="panel-loading">
    <div class="row">
      <div class="col-md-12">
        <div class="searchNofound">
          <img src="../assets/img/loading_ball.gif" style="width:40%;" alt="" srcset="">
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'panel-loading',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>
